export const FeaturesSection = () => {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'خصوصية عالية',
      description: 'نحافظ على سرية معلوماتك الطبية بأعلى معايير الأمان والخصوصية',
      color: 'bg-primary',
    },
    {
      icon: 'ri-user-star-line',
      title: 'أطباء معتمدون',
      description: 'فريق طبي متخصص ومعتمد في علاج الإدمان والطب النفسي',
      color: 'bg-secondary',
    },
    {
      icon: 'ri-time-line',
      title: 'متابعة مستمرة',
      description: 'نتابع معك خطوة بخطوة حتى تحقيق الهدف والتعافي الكامل',
      color: 'bg-accent',
    },
    {
      icon: 'ri-whatsapp-line',
      title: 'دعم عبر الواتساب',
      description: 'تواصل سريع ومباشر مع الفريق الطبي في أي وقت',
      color: 'bg-primary-600',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in">
          <h3 className="text-4xl md:text-5xl font-bold text-primary mb-4">لماذا عيادة الإقلاع؟</h3>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            نقدم لك <strong>تجربة علاجية متكاملة</strong> تجمع بين الاحترافية والرعاية الشخصية
          </p>
          <div className="w-24 h-1 bg-accent mx-auto mt-4"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className="text-center animate-slide-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className={`w-20 h-20 ${feature.color} rounded-full flex items-center justify-center mx-auto mb-6 shadow-xl hover:scale-110 transition-transform duration-300`}>
                <i className={`${feature.icon} text-white text-4xl`}></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-800 mb-4">{feature.title}</h4>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};